/**
 * Patient Waiting List Component
 * Shows lobby participants awaiting admission by therapist
 * Phase 7.1 - Session Management System
 */
import React from 'react';
/**
 * PatientWaitingList Component
 * Displays patients waiting in lobby with admit/reject controls
 */
export default function PatientWaitingList({ participants, onAdmit, onReject }) {
    if (participants.length === 0) {
        return (React.createElement("div", { style: styles.container },
            React.createElement("div", { style: styles.header },
                React.createElement("span", { style: styles.title }, "Waiting Room"),
                React.createElement("span", { style: styles.badge }, "0")),
            React.createElement("div", { style: styles.emptyMessage }, "No patients waiting")));
    }
    return (React.createElement("div", { style: styles.container },
        React.createElement("div", { style: styles.header },
            React.createElement("span", { style: styles.title }, "Waiting Room"),
            React.createElement("span", { style: styles.badge }, participants.length)),
        React.createElement("div", { style: styles.list }, participants.map((participant) => (React.createElement("div", { key: participant.id, style: styles.participantCard },
            React.createElement("div", { style: styles.participantInfo },
                React.createElement("div", { style: styles.participantName }, participant.name),
                participant.joinTime && (React.createElement("div", { style: styles.joinTime },
                    "Waiting ",
                    getWaitTime(participant.joinTime)))),
            React.createElement("div", { style: styles.actions },
                React.createElement("button", { style: { ...styles.actionButton, ...styles.admitButton }, onClick: () => onAdmit(participant.id), title: "Admit to session" }, "\u2713 Admit"),
                React.createElement("button", { style: { ...styles.actionButton, ...styles.rejectButton }, onClick: () => onReject(participant.id), title: "Reject entry" }, "\u2717 Reject"))))))));
}
/**
 * Calculate waiting time in human-readable format
 */
function getWaitTime(joinTime) {
    const seconds = Math.floor((Date.now() - joinTime.getTime()) / 1000);
    if (seconds < 60) {
        return `${seconds}s`;
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes}m`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
}
const styles = {
    container: {
        backgroundColor: '#2b2b2b',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '350px',
        maxWidth: '450px'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '16px'
    },
    title: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#fff',
        textTransform: 'uppercase',
        letterSpacing: '1px'
    },
    badge: {
        backgroundColor: '#FFC107',
        color: '#000',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    participantCard: {
        backgroundColor: '#1e1e1e',
        borderRadius: '6px',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        border: '1px solid #444'
    },
    participantInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    participantName: {
        fontSize: '15px',
        fontWeight: '500',
        color: '#fff'
    },
    joinTime: {
        fontSize: '12px',
        color: '#999'
    },
    actions: {
        display: 'flex',
        gap: '8px'
    },
    actionButton: {
        flex: 1,
        padding: '8px 12px',
        fontSize: '13px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    admitButton: {
        backgroundColor: '#4CAF50',
        color: 'white'
    },
    rejectButton: {
        backgroundColor: '#666',
        color: 'white'
    },
    emptyMessage: {
        textAlign: 'center',
        color: '#999',
        padding: '24px 16px',
        fontStyle: 'italic'
    }
};
